export default __webpack_public_path__ + "static/how-to-discover-your-perfect-winter-wonderland-2b12b506194afa7a0898f656c71b5eb5.jpg";